"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Icon_1 = require("../../atoms/Icon");

var IconLink_1 = require("../IconLink");

var Feedback =
/** @class */
function (_super) {
  __extends(Feedback, _super);

  function Feedback(props) {
    var _this = _super.call(this, props) || this;

    _this.onChange = function (result) {
      _this.setState({
        animationHide: true
      }, function () {
        return _this.props.onChange(result);
      });

      setTimeout(function () {
        _this.setState({
          animationHide: false
        });
      }, 250);
    };

    _this.onTrueClick = function () {
      _this.onChange(true);
    };

    _this.onFalseClick = function () {
      _this.onChange(false);
    };

    _this.state = {
      animationHide: false
    };
    return _this;
  }

  Feedback.prototype.render = function () {
    var _a = this.props,
        id = _a.id,
        className = _a.className,
        textBefore = _a.textBefore,
        textAfter = _a.textAfter,
        textButtonTrue = _a.textButtonTrue,
        textButtonFalse = _a.textButtonFalse,
        textResult = _a.textResult,
        result = _a.result;
    var animationHide = this.state.animationHide;
    var showResult = result !== undefined && !animationHide;
    return React.createElement("div", {
      className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "feedback", className, animationHide && result !== undefined && CSSPrefix_1.lsgPre + "feedback-hide"]),
      id: id
    }, !showResult && React.createElement(React.Fragment, null, React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "feedback-text-before"
    }, textBefore), React.createElement(IconLink_1.IconLinkGroup, {
      className: CSSPrefix_1.lsgPre + "feedback-buttons",
      direction: IconLink_1.IconLinkGroup.Directions.HORIZONTAL
    }, React.createElement(IconLink_1.IconLink, {
      iconName: Icon_1.Icon.Names.communication_feedback_happy,
      onClick: this.onTrueClick
    }, textButtonTrue), React.createElement(IconLink_1.IconLink, {
      iconName: Icon_1.Icon.Names.communication_feedback_neutral,
      onClick: this.onFalseClick
    }, textButtonFalse)), React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "feedback-text-after"
    }, textAfter)), showResult && React.createElement("div", {
      className: CSSPrefix_1.lsgPre + "feedback-text-result"
    }, textResult));
  };

  Feedback.defaultProps = {
    textButtonTrue: utils_1.Localization.texts && utils_1.Localization.texts.lsg.component.Feedback.trueButton,
    textButtonFalse: utils_1.Localization.texts && utils_1.Localization.texts.lsg.component.Feedback.falseButton,
    textResult: utils_1.Localization.texts && utils_1.Localization.texts.lsg.component.Feedback.result,
    onChange: function onChange() {
      /* empty */
    }
  };
  return Feedback;
}(React.Component);

exports.Feedback = Feedback;